import { useState } from "react";
import { Props } from "./types";
import { Link } from "react-scroll";

const CarouselItemDesktop = ({ index, scrollOffset = 0 }: Props): JSX.Element => {
  const [isActiveIndex, setActiveIndex] = useState(false);
  const handleSetActive = (to: any) => {
    if (index + 1 == to) {
      setActiveIndex(true);
    }
  };

  const handleSetInActive = (to: any) => {
    if (index + 1 == to) {
      setActiveIndex(false);
    }
  };

  return (
    <Link
      activeClass="border-landing-blue border-white"
      className={`relative w-auto lg:w-fill flex justify-center lg:justify-start items-center z-40 p-2 lg:my-3 cursor-pointer rounded-full border hover:border-landing-blue hover:border transition ease-in-out duration-300 bg-white`}
      spy
      hashSpy
      offset={scrollOffset}
      to={`${index + 1}`}
      onSetActive={handleSetActive}
      onSetInactive={handleSetInActive}
    >
      <div
        className={`relative rounded-full flex justify-center items-center max-w-md transition-all duration-300 ease-in-out ${
          isActiveIndex ? "bg-landing-blue" : "bg-landing-orange"
        } w-10 h-10`}
      >
        <span
          className={`z-30 text-2xl font-bold ${
            isActiveIndex ? "text-white" : "text-landing-blue"
          }`}
        >
          {index + 1}
        </span>
      </div>
    </Link>
  );
};

export default CarouselItemDesktop;
